exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-title-editor{position:relative}.c-title-editor .m-form-group{margin-bottom:0}.c-title-editor .m-dropdown-wrapper{right:initial;left:0}", ""]);

// exports
